"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertStringToColor = exports.setIconSize = exports.setIconColor = void 0;
var colorHelpers_1 = __importDefault(require("./utils/colorHelpers"));
var colors_1 = require("./constants/colors");
var setIconColor = function (secondary, disabled, theme) {
    var iconColor = 'white';
    if (secondary) {
        return colorHelpers_1.default('theme.axsui.components.buttons.secondary.color', theme, '#007def');
    }
    if (!secondary) {
        return colorHelpers_1.default('theme.axsui.components.buttons.primary.color' + ' !important', theme, '#007def');
    }
    if (disabled) {
        return colorHelpers_1.default('theme.axsui.white', theme, '#FFFFFF');
    }
    return iconColor;
};
exports.setIconColor = setIconColor;
var setIconSize = function (size, iconSize) {
    if (iconSize) {
        return iconSize;
    }
    switch (size) {
        case 'small':
            return '16px';
        case 'medium':
            return '16px';
        case 'large':
            return '20px';
        default:
            return '16px';
    }
};
exports.setIconSize = setIconSize;
var convertStringToColor = function (input) {
    var avatarColors = [colors_1.colors.ALIEN, colors_1.colors.ORCHID, colors_1.colors.MOJITO];
    var hash = hashString(input);
    var index = hash % avatarColors.length;
    return avatarColors[index];
};
exports.convertStringToColor = convertStringToColor;
var hashString = function (input) {
    var hash = 0;
    var i = 0;
    while (i < input.length) {
        var charCode = input.charCodeAt(i);
        hash += charCode;
        i += 1;
    }
    return hash;
};
//# sourceMappingURL=helpers.js.map